<script setup>
import EventForm from '@frontJs/components/forms/projectManagement/sem/EventForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { semEvent, tenants, tenant } = defineProps({
    tenants: {
        type: Array,
        required: false,
    },
    tenant: {
        type: Object,
        required: false,
    },
    semEvent: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="semEvent">
            Mettre à jour l'événement #{{ semEvent.id }} - Événements SEM -
            Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un événement - Événements - SEM - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="semEvent" :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Événements - Mettre à jour l'événement #{{
            semEvent.id
        }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - SEM - Événements - Créer un événement
    </PageTitle>

    <EventForm :tenants="tenants" :tenant="tenant" :sem-event="semEvent" />
</template>
